import * as l from "../../lib/littlejs.esm";
import { tiles, tilesize } from '../const/tiles.ts';
import Globals from '../globals';
class SmallPlatform extends l.EngineObject {
    constructor(pos) {
        super(pos, l.vec2(0.25, 0.25), l.tile(tiles.PLATFORM_MIDDLE, tilesize));
        this.setCollision(true, true, false, false);
        this.mass = 0; // Not affected by gravity
    }
    collideWithObject(object) {
        // Allow current player to pass through when jumping up
        if (object === Globals.player && object.velocity.y > 0) {
            return false;
        }
        // Normal collision otherwise
        return super.collideWithObject(object);
    }
    disableCollision() {
        this.setCollision(false, false, false, true);
    }
    enableCollision() {
        this.setCollision(true, true, false, false);
    }
}
export default SmallPlatform;
